import { Employee } from "../models/Employee";
import { Project } from "../models/Project";
import { AssignmentDemand } from "../models/AssignmentDemand";
import { Absence } from "../models/Absence";
import { Skill } from "../models/Skill";
import { SkillSet } from "../models/SkillSet";
import { EmploymentPeriod } from "../models/EmploymentPeriod";
import { Timestamp } from "firebase/firestore";
import { setLocalStorageWithExpiry } from "../common";
import { EmployeeUtilization } from "../models/EmployeeUtilization";


export function loadMockData() {
    //load mock data
    const today = new Date();
    const config = [
        {
            id: "locations", values: {
                "L-BCN": "Barcelona",
                "L-BER": "Berlin",
                "L-BTS": "Bratislava",
                "L-BUH": "Bukarest",
                "L-GRO": "Figueres",
                "L-HOME": "Home Office",
                "L-LIS": "Lisabon",
                "L-LPA": "Las Palmas",
                "L-MEX": "Mexico",
                "L-SGN": "Vietnam",
                "L-STR": "Stuttgart",
                "L-SVQ": "Sevilla"
            }
        },
        {
            id: "seniorities", values: {
                AN: "Analyst",
                SP: "Specialist",
                SE: "Senior Expert",
                MG: "Manager",
                PA: "Partner",
                YT: "Young Talent"
            }
        },
        {
            id: "projectRoles", values: {
                "R-ChangeManager": "Change Manager",
                "R-CloudArch": "Cloud Architect",
                "R-CloudDevOps": "Cloud DevOps",
                "R-CloudInfra": "Cloud Infrastructure",
                "R-CloudSap": "Cloud SAP",
                "R-CloudSecurity": "Cloud Security",
                "R-ConsultantSap": "SAP Consultant",
                "R-Data": "Data Engineer",
                "R-Dev": "Developer",
                "R-DevSap": "SAP Developer",
                "R-EE": "Electronics Engineering",
                "R-Exp": "Exploration",
                "R-GTM": "Go-to-market",
                "R-InternalTrainee": "Trainee",
                "R-PO": "PO / PM",
                "R-ServiceManager": "Service Manager",
                "R-Tester": "Tester",
                "R-UX": "UX Designer"
            }
        },
    ]

    const skillStructure: Skill[] = [
        {
            category: "Backend", skill: "Django", level: 0,
            name: ""
        },
        {
            category: "AI", skill: "Machine Learning",
            level: 0,
            name: ""
        },
        {
            category: "Project Management", skill: "Problem-Solving",
            level: 0,
            name: ""
        },
        {
            skill: "PHP", category: "Backend",
            level: 0,
            name: ""
        },
        {
            category: "DevOps - Automation and Deployment Tools", skill: "Jenkins",
            level: 0,
            name: ""
        },
        {
            skill: "Firebase Messaging", category: "DevOps - Automation and Deployment Tools",
            level: 0,
            name: ""
        },
        {
            skill: "REST", category: "Frontend & Mobile",
            level: 0,
            name: ""
        },
        {
            skill: "Usability Research", category: "UX",
            level: 0,
            name: ""
        },
        {
            skill: "Change Management", category: "Project Management",
            level: 0,
            name: ""
        },
        {
            skill: "HTML", category: "Frontend & Mobile",
            level: 0,
            name: ""
        },
        {
            category: "UX", skill: "Sketch",
            level: 0,
            name: ""
        },
        {
            category: "DevOps - Automation and Deployment Tools", skill: "Sentry",
            level: 0,
            name: ""
        },
        {
            skill: "Contentful (hCMS)", category: "DevOps - Automation and Deployment Tools",
            level: 0,
            name: ""
        },
        {
            category: "Cloud Platforms", skill: "Microsoft Azure",
            level: 0,
            name: ""
        },
        {
            category: "Project Management", skill: "Trello",
            level: 0,
            name: ""
        },
        {
            category: "Frontend & Mobile", skill: "GraphQL",
            level: 0,
            name: ""
        },
        {
            category: "Backend - Databases", skill: "MongoDB",
            level: 0,
            name: ""
        },
        {
            skill: "ChatGPT", category: "AI",
            level: 0,
            name: ""
        },
        {
            category: "Cloud - Services", skill: "VMware Stack",
            level: 0,
            name: ""
        },
        {
            category: "Cloud - Tools", skill: "Terraform",
            level: 0,
            name: ""
        },
        {
            category: "Cloud Platforms", skill: "Amazon Web Services",
            level: 0,
            name: ""
        },
        {
            skill: "Bootstrap", category: "Frontend & Mobile",
            level: 0,
            name: ""
        },
        {
            category: "SAP", skill: "PP",
            level: 0,
            name: ""
        },
        {
            category: "SAP", skill: "PI / PO",
            level: 0,
            name: ""
        },
        {
            skill: "Figma", category: "UX",
            level: 0,
            name: ""
        },
        {
            skill: "Embedded C++", category: "Firmware",
            level: 0,
            name: ""
        },
        {
            skill: "Value Proposition Canvas", category: "Project Management",
            level: 0,
            name: ""
        },
        {
            category: "Testing", skill: "BDD",
            level: 0,
            name: ""
        }
    ];

    // Mock data, with 100 common employees names and 100 common project names

    //generate random employee data
    const firstNames = ["James", "John", "Robert", "Michael", "William", "David", "Richard", "Joseph", "Thomas", "Charles", "Christopher", "Daniel", "Matthew", "Anthony", "Donald", "Mark", "Paul", "Steven", "Andrew", "Kenneth", "Joshua", "Kevin", "Brian", "George", "Edward", "Ronald", "Timothy", "Jason", "Jeffrey", "Ryan", "Jacob", "Gary", "Nicholas", "Eric", "Stephen", "Jonathan", "Larry", "Justin", "Scott", "Brandon", "Benjamin", "Samuel", "Frank", "Gregory", "Raymond", "Alexander", "Patrick", "Jack", "Dennis", "Jerry", "Tyler", "Aaron", "Jose", "Henry", "Adam", "Douglas", "Nathan", "Peter", "Zachary", "Kyle", "Walter", "Harold", "Jeremy", "Ethan", "Carl", "Keith", "Roger", "Gerald", "Christian", "Terry", "Sean", "Arthur", "Austin", "Noah", "Lawrence", "Jesse", "Joe", "Bryan", "Billy", "Jordan", "Albert", "Dylan", "Bruce", "Willie", "Gabriel", "Alan", "Juan", "Logan", "Wayne", "Ralph", "Roy", "Eugene", "Randy", "Vincent", "Russell", "Louis", "Philip", "Bobby", "Johnny", "Bradley"];
    const lastNames = ["Smith", "Johnson", "Williams", "Jones", "Brown", "Davis", "Miller", "Wilson", "Moore", "Taylor", "Anderson", "Thomas", "Jackson", "White", "Harris", "Martin", "Thompson", "Garcia", "Martinez", "Robinson", "Clark", "Rodriguez", "Lewis", "Lee", "Walker", "Hall", "Allen", "Young", "Hernandez", "King", "Wright", "Lopez", "Hill", "Scott", "Green", "Adams", "Baker", "Gonzalez", "Nelson", "Carter", "Mitchell", "Perez", "Roberts", "Turner", "Phillips", "Campbell", "Parker", "Evans", "Edwards", "Collins", "Stewart", "Sanchez", "Morris", "Rogers", "Reed", "Cook", "Morgan", "Bell", "Murphy", "Bailey", "Rivera", "Cooper", "Richardson", "Cox", "Howard", "Ward", "Torres", "Peterson", "Gray", "Ramirez", "James", "Watson", "Brooks", "Kelly", "Sanders", "Price", "Bennett", "Wood", "Barnes", "Ross", "Henderson", "Coleman", "Jenkins", "Perry", "Powell", "Long", "Patterson", "Hughes", "Flores", "Washington", "Butler", "Simmons", "Foster", "Gonzales", "Bryant", "Alexander", "Russell", "Griffin", "Diaz", "Hayes"];

    const employees: Employee[] = [];

    function getRandomElement(arr: any[]) {
        return arr[Math.floor(Math.random() * arr.length)];
    }

    const locationsItem = config.find(item => item.id === "locations");
    const locations = locationsItem ? locationsItem.values : {};
    const senioritiesItem = config.find(item => item.id === "seniorities");
    const seniorities = senioritiesItem ? senioritiesItem.values : {};
    const projectRolesItem = config.find(item => item.id === "projectRoles");
    const projectRoles = projectRolesItem ? projectRolesItem.values : {};

    for (let i = 0; i < 100; i++) {
        let employeeName = `${getRandomElement(firstNames)} ${getRandomElement(lastNames)}`;
        let id = employeeName.toLowerCase().split(' ').join('.');
        var employee = new Employee({
            employeeName: employeeName,
            id: id,
            seniority: getRandomElement(Object.values(seniorities)),
            role: getRandomElement(Object.values(projectRoles)),

            location: getRandomElement(Object.values(locations)),
            remote: Math.random() > 0.5
        });
        employee.skills = new SkillSet(randomSkills(skillStructure)),
            employee.employmentPeriods = [
                new EmploymentPeriod(new Date(today.getFullYear() - 2, Math.floor(Math.random() * 12), Math.floor(Math.random() * 28)),
                    new Date(today.getFullYear() + 2, Math.floor(Math.random() * 12), Math.floor(Math.random() * 28)), 40)

            ];
        employees.push(employee);
    }
    //generate random project data
    var projectNames = ["Agilify", "CloudHive", "DataSphere", "ElevateX", "FusionIQ", "Hypernova", "InnovateNow", "JupiterOne", "Kinetix", "LiftOff", "MomentumX", "NimbleTech", "OptiMind", "PulseTech", "QuantumLeap", "RocketHub", "SynapseX", "TechFuse", "UpliftX", "VelocityIQ"]
    var projectTypes = ["AI", "Frontend", "Mobile", "Backend", "Database", "Data", "DevOps", "Testing", "UX", "Framework", "SAP", "Update"];
    const projects: Project[] = [];
    for (var i = 0; i < 100; i++) {
        let date1 = new Date(new Date().getFullYear(), Math.floor(Math.random() * 12), Math.floor(Math.random() * 28));
        let date2 = new Date(new Date().getFullYear(), Math.floor(Math.random() * 12), Math.floor(Math.random() * 28));

        projects.push(new Project({
            id: "Z23-" + i,
            projectName: projectNames[Math.floor(Math.random() * projectNames.length)] + " " + projectTypes[Math.floor(Math.random() * projectTypes.length)] + " " + (i + 1),
            startDate: new Date(Math.min(date1.getTime(), date2.getTime())),
            endDate: new Date(Math.max(date1.getTime(), date2.getTime())),
        }));
    }


    //generate random assignment data
    const assignments: AssignmentDemand[] = [];

    for (let i = 0; i < projects.length; i++) {
        for (let j = 0; j <= Math.floor(Math.random() * 100); j++) {
            let date1 = new Date(today.getFullYear(), Math.floor(Math.random() * 12), Math.floor(Math.random() * 28));
            let date2 = new Date(today.getFullYear(), Math.floor(Math.random() * 12), Math.floor(Math.random() * 28));

            const assignment = new AssignmentDemand({
                dueDate: new Date(Math.min(date1.getTime(), date2.getTime())),
                chanceToWin: Math.floor(Math.random() * 100),
                project: projects[i],
                status: AssignmentDemand.AllDemandStatuses[Math.floor(Math.random() * AssignmentDemand.AllDemandStatuses.length)],
                description: "Automatically generated assignment",
                pdTotalPlanned: Math.floor(Math.random() * 100),
                projectId: projects[i].id,
                employeeId: employees[Math.floor(Math.random() * employees.length)].id,
                role: getRandomElement(Object.values(projectRoles)),
                startDate: new Date(Math.min(date1.getTime(), date2.getTime())),
                endDate: new Date(Math.max(date1.getTime(), date2.getTime())),

            });




            assignment.skills = new SkillSet(randomSkills(skillStructure, 3));
            // Calculate for each week of the year if the project was active
            // this.#randomCalendarWeeks(this.today, assignment);

            assignments.push(assignment);
        }
    }
    const absences: Absence[] = [];

    for (var i = 0; i < employees.length; i++) {
        for (var j = 0; j <= Math.floor(Math.random() * 10); j++) {
            let date1 = new Date(today.getFullYear(), Math.floor(Math.random() * 12), Math.floor(Math.random() * 28));
            let date2 = new Date(today.getFullYear(), Math.floor(Math.random() * 12), Math.floor(Math.random() * 28));

            var absence = new Absence(employees[i].id, Timestamp.fromDate(new Date(Math.min(date1.getTime(), date2.getTime()))), Timestamp.fromDate(new Date(Math.max(date1.getTime(), date2.getTime()))), Math.random() < 0.5);

            absences.push(absence);
        }
    }

    const employeesUtilization: EmployeeUtilization[] = [];

    const mock_ttl = 6 * 60 * 60 * 1000;
    setLocalStorageWithExpiry("config", config, mock_ttl);
    setLocalStorageWithExpiry("skillCategories", skillStructure, mock_ttl);
    setLocalStorageWithExpiry("employees", employees, mock_ttl);
    setLocalStorageWithExpiry("projects", projects, mock_ttl);
    setLocalStorageWithExpiry("assignments", assignments, mock_ttl);
    setLocalStorageWithExpiry("absences", absences, mock_ttl);
    setLocalStorageWithExpiry("employeesUtilization", employeesUtilization, mock_ttl);

    console.log("Generated random data and cached.");
}


export function randomSkills(skillStructure: Skill[], maxSkills = 9): Skill[] {
    const numSkills = Math.floor(Math.random() * maxSkills + 1);
    const skills: Skill[] = [];

    for (let i = 0; i < numSkills; i++) {
        const skillObj = skillStructure[Math.floor(Math.random() * skillStructure.length)];
        const skill = new Skill(skillObj.category, skillObj.skill, Math.floor(Math.random() * 4 + 1));
        skills.push(skill);
    }

    return skills;
}